'use client';

import Script from 'next/script';

interface GoogleAnalyticProps {
  gaId?: string;
  headScript?: string;
  bodyScript?: string;
}

export function GoogleAnalytic({ gaId, headScript, bodyScript }: GoogleAnalyticProps) {
  const resolvedHeadScript =
    headScript ||
    (gaId
      ? `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', '${gaId}');
      `.trim()
      : null);

  return (
    <>
      {resolvedHeadScript && (
        <Script
          id="ga-head"
          strategy="afterInteractive"
          dangerouslySetInnerHTML={{ __html: resolvedHeadScript }}
        />
      )}
      {gaId && (
        <Script
          id="ga-script"
          strategy="afterInteractive"
          src={`https://www.googletagmanager.com/gtag/js?id=${gaId}`}
          async
        />
      )}
      {bodyScript && (
        <div dangerouslySetInnerHTML={{ __html: bodyScript }} />
      )}
    </>
  );
}